export enum InmarItemIdResolutionSource {
  SKU = "sku",
  UPC_BARCODE = "upc",
  MANUAL = "manual",
}

export const idResolutionSourceToDisplayText: Record<
  InmarItemIdResolutionSource,
  string
> = {
  [InmarItemIdResolutionSource.SKU]: "SKU",
  [InmarItemIdResolutionSource.UPC_BARCODE]: "UPC Barcode",
  [InmarItemIdResolutionSource.MANUAL]: "Manual",
};
